










import { Component, Vue } from 'vue-property-decorator';
import RegionIndex from '@/views/system/organization/region/unit/index.vue';
import DrawMap from '@/views/system/organization/region/unit/drawMap.vue';

@Component({
  components: { RegionIndex, DrawMap },
})
export default class Company extends Vue {
  showFlag = 1; // 展示主页组件或者编辑和新增组件 :1 是主页组件 2 是编辑 3 是新增下级 4 是新增
  row = {}; // index组件向编辑组件传值
}
